import * as actions from './actions'
import { saveEntities } from '../factories'
import { sequences as route } from '../route'
import { showFeedback } from '../feedback/factories'
import { set } from 'cerebral/factories'
import { props } from 'cerebral'

export const find = [
  actions.find,
  saveEntities(),
]

export const findForList = [
  set(props`useRouteParams`, true),
  actions.clearList,
  actions.find,
  actions.setList,
  saveEntities(),
]

export const get = [
  actions.get,
  saveEntities(),
]

export const save = [
  actions.save,
  saveEntities(),
  showFeedback({ title: 'Alert saved', type: 'success' }),
  route.toAlerts,
]

export const remove = [
  actions.remove,
  showFeedback({ title: 'Alert cleared', type: 'success' }),
  find,
]
